import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { services } from '../../data/services';
const ease = [0.23, 1, 0.32, 1] as const;
export function ServicesSection() {
  const [featured, ...others] = services;
  return <section aria-labelledby="services-title" className="w-full bg-ink text-white" data-id="element-109" data-mp="3u5kdthzkvsyy">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-110" data-mp="lo5yv2ftaeer">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-111" data-mp="qnsefij446qq">
          <h2 id="services-title" className="max-w-2xl font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-6xl" data-id="element-112" data-mp="qlg0rhke0ijh">
            Dedans, dehors, <span className="text-lime" data-id="element-113" data-mp="gol310vxum69">et même chez vous.</span>
          </h2>
          <Link to="/prestations" className="group inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-white/80 transition-colors duration-150 ease-out hover:text-lime" data-id="element-114" data-mp="2wg8yervb06my">
            Toutes les prestations
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-115" data-mp="46l7w992kf2b" />
          </Link>
        </div>

        <div className="mt-14 grid gap-5 lg:grid-cols-12" data-id="element-116" data-mp="d79lx3ygqff7">
          <motion.article initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease
        }} className="group relative isolate flex min-h-[560px] flex-col justify-end overflow-hidden rounded-3xl lg:col-span-7 lg:row-span-3" data-id="element-117" data-mp="87n92vmjr16x">
            <img src={featured.image} alt={featured.alt} className="absolute inset-0 -z-10 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-118" data-mp="vysnd6cu9lf4" />
            <div className="absolute inset-0 -z-10 bg-ink/45" aria-hidden="true" data-id="element-119" data-mp="15t1h1xdlvkev" />
            <div className="m-3 rounded-2xl bg-ink/80 p-7 backdrop-blur-md sm:m-4 sm:p-9" data-id="element-120" data-mp="10xm0uys4lcfa">
              <span className="inline-block rounded-full bg-lime px-3 py-1 text-xs font-semibold text-ink" data-id="element-121" data-mp="3uplsrnpio501">{featured.tag}</span>
              <h3 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-122" data-mp="2hvpdwcgnv36">{featured.title}</h3>
              <p className="mt-3 max-w-lg leading-relaxed text-white/75" data-id="element-123" data-mp="ca1gl3uw28hb">{featured.text}</p>
              <Link to="/tarifs" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-lime hover:text-white" data-id="element-124" data-mp="cbvzkcmlnqir">
                Voir les tarifs
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="m6o11rjayxit" />
              </Link>
            </div>
          </motion.article>

          {others.map((service, i) => <motion.article key={service.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease
        }} className="group grid grid-cols-[120px_1fr] gap-5 rounded-3xl border border-white/10 bg-ink-2 p-3 pr-6 sm:grid-cols-[160px_1fr] lg:col-span-5" data-id="element-126" data-mp="v7uka8dc6mfr" data-mpi={i}>
              <div className="overflow-hidden rounded-2xl" data-id="element-127" data-mp="2ko816m0tvlpj">
                <img src={service.image} alt={service.alt} className="h-full min-h-[140px] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.05]" data-id="element-128" data-mp="2frhj5t5gqg1h" />
              </div>
              <div className="flex flex-col py-3" data-id="element-129" data-mp="38f3md0as3int">
                <span className="text-xs font-medium text-sky" data-id="element-130" data-mp="33gscwqoeba64">{service.tag}</span>
                <h3 className="mt-1.5 font-display text-xl font-bold tracking-tight" data-id="element-131" data-mp="33epkjzzrt4y8">{service.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-fog" data-id="element-132" data-mp="2ufugouk786y3">{service.text}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}